import * as React from 'react';
import { LoadingSpinner } from '../LoadingSpinner';
import { SVG } from '../../Utils/SVG';
// TODO: Remove this from project?
const cameraIconURL = require('../../../icons/camera.svg');
import './style.css';

export interface FixedAspectImageProps {
  aspectHeight?: number;
  aspectWidth?: number;
  className?: string;
  loader?: (showPlaceholder?: boolean) => JSX.Element;
  preload?: boolean;
  renderChildrenBeforeLoaded?: boolean;
  src: string;
  showPlaceholder?: boolean;
}

export interface FixedAspectImageState {
  loadedSrc?: string;
}

// TODO: Use FixedAspect in this component?  Not entirely trivial due to the aria attrs etc.
export class FixedAspectImage extends React.Component<
  FixedAspectImageProps,
  FixedAspectImageState
> {
  static loadedImages = {};

  private safeSetState: (state: FixedAspectImageState) => void;

  static get defaultProps(): Partial<FixedAspectImageProps> {
    return {
      aspectHeight: 9,
      aspectWidth: 16,
      loader: FixedAspectImage.defaultLoader,
      // NOTE: Actually seems to work better without preload on low bandwidth emulation
      preload: false,
      renderChildrenBeforeLoaded: false,
      showPlaceholder: false
    };
  }

  static defaultLoader(showPlaceholder?: boolean): JSX.Element {
    return (
      <div className="loading-image-placeholder">
        {showPlaceholder ? (
          <SVG className="loading-image-placeholder-icon" src={cameraIconURL} />
        ) : null}
        <LoadingSpinner />
      </div>
    );
  }

  constructor(props: FixedAspectImageProps) {
    super(props);

    this.state = {
      loadedSrc: FixedAspectImage.loadedImages[props.src]
    };
  }

  async componentDidMount() {
    this.safeSetState = (state: FixedAspectImageState) => this.setState(state);
    await this.preloadImage();
  }

  async UNSAFE_componentWillReceiveProps(newProps: FixedAspectImageProps) {
    await this.preloadImage();
  }

  componentWillUnmount() {
    this.safeSetState = () => undefined;
  }

  render() {
    const {
      aspectHeight,
      aspectWidth,
      children,
      className,
      loader,
      renderChildrenBeforeLoaded,
      showPlaceholder
    } = this.props;
    const { loadedSrc } = this.state;

    const showImage = loadedSrc || !loader;

    return (
      <div
        className={`${
          className ? `${className} ` : ``
        }fixed-aspect-image-wrapper`}
      >
        <div
          className="fixed-aspect-image"
          role="img"
          aria-live="polite"
          aria-busy={!showImage}
          style={{
            paddingTop: `${(100 * (aspectHeight as number)) /
              (aspectWidth as number)}%`,
            backgroundImage: showImage
              ? `url(${encodeURI(loadedSrc || '')})`
              : undefined
          }}
        />
        {!showImage && loader ? loader(showPlaceholder) : null}
        {renderChildrenBeforeLoaded || showImage ? children : null}
      </div>
    );
  }

  private preloadImage = async () => {
    const { preload, src } = this.props;

    if (FixedAspectImage.loadedImages[src]) {
      this.setState({
        loadedSrc: FixedAspectImage.loadedImages[src]
      });

      return;
    }

    const loadedSrc = preload ? await this.loadImage(src) : src;

    FixedAspectImage.loadedImages[src] = loadedSrc;

    this.safeSetState({
      loadedSrc: FixedAspectImage.loadedImages[src]
    });
  };

  private loadImage = async (src: string): Promise<string> => {
    const img = new Image();

    await new Promise((resolve, reject) => {
      img.onload = resolve;
      img.onerror = reject;
      img.src = src;
    });

    return src;
  };
}

export default FixedAspectImage;



// WEBPACK FOOTER //
// ./src/app/components/Common/FixedAspectImage/index.tsx